<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @close="onClose">
    <h3 style="margin-left: 16px; font-weight: bold;">{{ formTitle }}</h3>

    <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
    >
      <a-divider orientation="left">推送设置</a-divider>

      <a-form-model-item label="跳转页面" prop="toPage">
        <a-select
            v-model="form.toPage"
            placeholder="请选择"
            :disabled="isViewMode"
            optionLabelProp="children"
        >
          <a-select-option :value="1">目标页面</a-select-option>
          <a-select-option :value="2">指定页面</a-select-option>
          <a-select-option :value="3">短剧</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="跳转地址" prop="targetUrl" v-if="form.toPage == 1">
        <a-input v-model="form.targetUrl" placeholder="请输入目标链接地址" :disabled="isViewMode" />
      </a-form-model-item>

      <a-form-model-item label="客户端页面" prop="appointPage" v-if="form.toPage == 2">
        <a-select
            v-model="form.appointPage"
            placeholder="请选择页面"
            :disabled="isViewMode"
            option-label-prop="children"
        >
          <a-select-option :value="1">首页</a-select-option>
          <a-select-option :value="2">剧场</a-select-option>
          <a-select-option :value="3">福利</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="目标短剧" prop="targetId" v-if="form.toPage == 3">
        <a-input
            v-model="selectedVideoName"
            placeholder="点击选择短剧"
            readonly
            :disabled="isViewMode"
            @click="!isViewMode && openVideoSelector()"
        />
      </a-form-model-item>

      <a-form-model-item label="推送用户" prop="toUser">
        <a-select v-model="form.toUser" placeholder="请选择" :disabled="isViewMode">
          <a-select-option :value="1">全站</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="时间类型" prop="timeType">
        <a-select v-model="form.timeType" placeholder="请选择" :disabled="isViewMode">
          <a-select-option :value="1">立即发送</a-select-option>
          <a-select-option :value="2">定时发送</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="发送时间" prop="sendTime" v-if="form.timeType === 2">
        <a-date-picker
            style="width: 100%"
            v-model="form.sendTime"
            format="YYYY-MM-DD HH:mm"
            :show-time="{ format: 'HH:mm' }"
            allow-clear
            :disabled="isViewMode"
        />
      </a-form-model-item>

      <a-divider orientation="left">消息内容</a-divider>

      <a-form-model-item label="简体中文消息标题" prop="titleCn">
        <a-input v-model="form.titleCn" allow-clear :disabled="isViewMode" />
      </a-form-model-item>
      <a-form-model-item label="简体中文消息内容" prop="contentCn">
        <a-textarea :rows="3" v-model="form.contentCn" :disabled="isViewMode" />
      </a-form-model-item>

      <a-form-model-item label="繁体中文消息标题" prop="title">
        <a-input v-model="form.title" allow-clear :disabled="isViewMode" />
      </a-form-model-item>
      <a-form-model-item label="繁体中文消息内容" prop="content">
        <a-textarea :rows="3" v-model="form.content" :disabled="isViewMode" />
      </a-form-model-item>

      <a-form-model-item label="英文消息标题" prop="titleEn">
        <a-input v-model="form.titleEn" allow-clear :disabled="isViewMode" />
      </a-form-model-item>
      <a-form-model-item label="英文消息内容" prop="contentEn">
        <a-textarea :rows="3" v-model="form.contentEn" :disabled="isViewMode" />
      </a-form-model-item>

      <a-form-model-item label="马来语消息标题" prop="titleBm">
        <a-input v-model="form.titleBm" allow-clear :disabled="isViewMode" />
      </a-form-model-item>
      <a-form-model-item label="马来语消息内容" prop="contentBm">
        <a-textarea :rows="3" v-model="form.contentBm" :disabled="isViewMode" />
      </a-form-model-item>

      <a-form-model-item label="印尼语消息标题" prop="titleIn">
        <a-input v-model="form.titleIn" allow-clear :disabled="isViewMode" />
      </a-form-model-item>
      <a-form-model-item label="印尼语消息内容" prop="contentIn">
        <a-textarea :rows="3" v-model="form.contentIn" :disabled="isViewMode" />
      </a-form-model-item>

      <a-row v-if="!isViewMode" type="flex" justify="end" style="margin-top: 24px;">
        <a-space>
          <a-button @click="cancel">取消</a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
        </a-space>
      </a-row>
    </a-form-model>

    <video-selector :visible="selectorVisible" @close="selectorVisible = false" @select="handleVideoSelect" />
  </a-drawer>
</template>

<script>
import { getPush, addPush, updatePush } from '@/api/video/push'
import VideoSelector from './VideoSelector.vue'

export default {
  name: 'CreateForm',
  components: { VideoSelector },
  data() {
    return {
      open: false,
      mode: 'add', // add | edit | view
      formTitle: '',
      submitLoading: false,
      formKey: 0,
      form: {
        id: null,
        toPage: null,
        targetId: null,
        targetUrl: null,
        appointPage: null,
        toUser: null,
        timeType: null,
        sendTime: null,
        titleCn: null,
        contentCn: null,
        title: null,
        content: null,
        titleEn: null,
        contentEn: null,
        titleBm: null,
        contentBm: null,
        titleIn: null,
        contentIn: null
      },
      selectorVisible: false,
      selectedVideoName: '',
      rules: {
        toPage: [{ required: true, message: '跳转类型不能为空' }],
        toUser: [{ required: true, message: '推送用户不能为空' }],
        timeType: [{ required: true, message: '时间类型不能为空' }],
        sendTime: [{ required: true, message: '发送时间不能为空' }],
        titleCn: [{ required: true, message: '简体中文标题不能为空' }],
        contentCn: [{ required: true, message: '简体中文内容不能为空' }],
        title: [{ required: true, message: '繁体中文标题不能为空' }],
        content: [{ required: true, message: '繁体中文内容不能为空' }],
        titleEn: [{ required: true, message: '英文标题不能为空' }],
        contentEn: [{ required: true, message: '英文内容不能为空' }],
        titleBm: [{ required: true, message: '马来语标题不能为空' }],
        contentBm: [{ required: true, message: '马来语内容不能为空' }],
        titleIn: [{ required: true, message: '印尼语标题不能为空' }],
        contentIn: [{ required: true, message: '印尼语内容不能为空' }]
      }
    }
  },
  computed: {
    isViewMode() {
      return this.mode === 'view'
    }
  },
  methods: {
    initForm() {
      return {
        id: null,
        toPage: null,
        targetId: null,
        targetUrl: null,
        appointPage: null,
        toUser: null,
        timeType: null,
        sendTime: null,
        titleCn: null,
        contentCn: null,
        title: null,
        content: null,
        titleEn: null,
        contentEn: null,
        titleBm: null,
        contentBm: null,
        titleIn: null,
        contentIn: null
      }
    },
    openVideoSelector() {
      this.selectorVisible = true
    },
    handleVideoSelect(video) {
      this.form.targetId = video.id
      this.selectedVideoName = video.videoName
      this.selectorVisible = false
      console.log('已选短剧 targetId:', video.id) // 调试用
    },
    onClose() {
      this.open = false
    },
    reset() {
      for (const key in this.form) {
        this.form[key] = null
      }
      this.selectedVideoName = ''
      this.$nextTick(() => {
        this.$refs.form?.clearValidate()
      })
    },
    cancel() {
      this.open = false
      this.reset()
    },
    handleAdd() {
      this.reset()
      this.mode = 'add'
      this.formTitle = '新增消息'
      this.open = true
    },
    handleUpdate(row) {
      this.reset()
      this.mode = 'edit'
      getPush({ id: row.id }).then(res => {
        const data = res.data
        for (const key in this.form) {
          this.form[key] = data[key] || null
        }
        // 手动覆盖字段（兼容旧数据）
        this.form.titleCn = data.titleCn || data.title
        this.form.contentCn = data.contentCn || data.content
        this.selectedVideoName = data.videoName || ''
        this.formTitle = '编辑消息'
        this.open = true
      })
    },
    handleView(row) {
      this.reset()
      this.mode = 'view'
      getPush({ id: row.id }).then(res => {
        const data = res.data

        Object.assign(this.form, {
          ...this.initForm(),
          ...data,
          titleCn: data.titleCn || data.title,
          contentCn: data.contentCn || data.content
        })

        this.selectedVideoName = data.videoName || ''
        this.formTitle = '查看消息'
        this.open = true
      })
    },
    formatDateTime(date) {
      if (!date) return null
      const d = new Date(date)
      const pad = n => n.toString().padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    submitForm() {
      console.log('[DEBUG] 提交前 toPage:', this.form.toPage)
      console.log('[DEBUG] 提交前 targetId:', this.form.targetId)

      if (this.form.toPage === 1 && !this.form.targetUrl) {
        this.$message.error('请输入跳转链接地址')
        return
      }

      if (this.form.toPage === 2 && this.form.appointPage == null) {
        this.$message.error('请选择客户端页面')
        return
      }

      if (this.form.toPage === 3 && this.form.targetId == null) {
        this.$message.error('请选择短剧')
        return
      }

      this.$refs.form.validate(valid => {
        if (!valid) return

        this.submitLoading = true

        // ✅ 清除当前不使用的字段（注意保留 targetId）
        if (this.form.toPage === 1) {
          this.form.appointPage = null
        } else if (this.form.toPage === 2) {
          this.form.targetUrl = null
        } else if (this.form.toPage === 3) {
          this.form.targetUrl = null
          this.form.appointPage = null
        }

        const payload = {
          ...this.form,
          sendTime: this.formatDateTime(this.form.sendTime)
        }

        const api = this.form.id ? updatePush : addPush
        api(payload)
            .then(() => {
              this.$message.success(this.form.id ? '修改成功' : '新增成功')
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
      })
    }

  }
}
</script>
